export default [{
    path: '/h5-migration',
    name: 'h5-migration',
    meta: {
        title: "迁移通知",
        requiresAuth: false,
    },
    component: () =>
        import ( /* webpackChunkName: 'h5-migration' */ './ielts-migration/index.vue')
}]